import ATabsItem from './TabsItem';
export default ATabsItem;


// WEBPACK FOOTER //
// ./src/packages/TabsItem/index.js